const prefix = 'STATE_MANAGER/';
export const UPDATE_CANVAS_STATE_SAGA = `${prefix}UPDATE_CANVAS_STATE_SAGA`;
export const UNDO_SAGA = `${prefix}UNDO_SAGA`;
export const REDO_SAGA = `${prefix}REDO_SAGA`;
